import { createContext } from 'react';

import { AbortControllerContextType } from '../types/abort-controller.types.ts';

export const AbortControllerContext = createContext<AbortControllerContextType | null>(null);
